import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import moment from "moment";
import ReviewKYCModal from "./ReviewKYCModal";
import { adminActions } from "../../../redux/actions";
import MainApp from "../../layouts/MainApp";

export default function KYCUserDetails() {
  const dispatch = useDispatch();
  const params = useParams();

  const singleVerification = useSelector(
    (state) => state.admin.singleVerification
  );

  useEffect(() => {
    if (params?.id) {
      dispatch(adminActions.showAHumanVerification(params?.id));
    }
    // eslint-disable-next-line
  }, [params?.id]);

  return (
    <MainApp>
      <div className="main-content-padding">
        <div className="main-content">
          <div className="border border-[#E4E4F3] dark:border-none bg-white dark:bg-[#121212] rounded-md py-3 px-4 sm:px-8 mb-4">
            <div className="border-b border-[#E4E4F3] py-3 flex justify-between items-center">
              <h3 className="text-lg font-medium">User Details</h3>
            </div>

            <div className="row mt-3 g-0">
              <div className="col-6 col-sm-3 col-md-2 px-2 px-sm-3">
                <label className="text-[#9CA3AF] dark:text-[#BCBCBC] text-sm mb-2">
                  Name:
                </label>
                <p className="text-[#151515] dark:text-white text-sm font-bold">
                  {singleVerification?.user?.name}
                </p>
              </div>
              <div className="col-6 col-sm-3 col-md-2 px-2 px-sm-3">
                <label className="text-[#9CA3AF] dark:text-[#BCBCBC] text-sm mb-2">
                  Gender:
                </label>
                <p className="text-[#151515] dark:text-white text-sm font-bold">
                  {singleVerification?.user?.gender}
                </p>
              </div>
              <div className="col-6 col-sm-3 col-md-2 px-2 px-sm-3">
                <label className="text-[#9CA3AF] dark:text-[#BCBCBC] text-sm mb-2">
                  Email:
                </label>
                <p className="text-[#151515] dark:text-white text-sm font-bold">
                  {singleVerification?.user?.email}
                </p>
              </div>
              <div className="col-6 col-sm-3 col-md-2 px-2 px-sm-3">
                <label className="text-[#9CA3AF] dark:text-[#BCBCBC] text-sm mb-2">
                  Phone number:
                </label>
                <p className="text-[#151515] dark:text-white text-sm font-bold">
                  {singleVerification?.user?.phone}
                </p>
              </div>

              <div className="col-6 col-sm-3 col-md-2 px-2 px-sm-3">
                <label className="text-[#9CA3AF] dark:text-[#BCBCBC] text-sm mb-2">
                  Date Created:
                </label>
                <p className="text-[#151515] dark:text-white text-sm font-bold">
                  {moment(singleVerification?.user?.created_at).format(
                    "MMM DD, YYYY"
                  )}
                </p>
              </div>
              <div className="col-6 col-sm-3 col-md-2 px-2 px-sm-3">
                <label className="text-[#9CA3AF] dark:text-[#BCBCBC] text-sm mb-2">
                  KYC Document:
                </label>
                <p className="text-[#151515] dark:text-white text-sm font-bold">
                  {singleVerification?.document_type}
                </p>
              </div>
              <div className="col-6 col-sm-3 col-md-2 px-2 px-sm-3">
                <label className="text-[#9CA3AF] dark:text-[#BCBCBC] text-sm mb-2">
                  Licence No:
                </label>
                <p className="text-[#151515] dark:text-white text-sm font-bold">
                  {singleVerification?.document_number}
                </p>
              </div>

              <div className="col-6 col-sm-3 col-md-2 px-2 px-sm-3">
                <label className="text-[#9CA3AF] dark:text-[#BCBCBC] text-sm mb-2">
                  Country:
                </label>
                <p className="text-[#151515] dark:text-white text-sm font-bold">
                  {singleVerification?.user?.country}
                </p>
              </div>
              <div className="col-6 col-sm-3 col-md-2 px-2 px-sm-3">
                <label className="text-[#9CA3AF] dark:text-[#BCBCBC] text-sm mb-2">
                  City:
                </label>
                <p className="text-[#151515] dark:text-white text-sm font-bold">
                  {singleVerification?.user?.city}
                </p>
              </div>
              <div className="col-6 col-sm-3 col-md-2 px-2 px-sm-3">
                <label className="text-[#9CA3AF] dark:text-[#BCBCBC] text-sm mb-2">
                  State:
                </label>
                <p className="text-[#151515] dark:text-white text-sm font-bold">
                  {singleVerification?.user?.state}
                </p>
              </div>
            </div>
          </div>

          <div className="border border-[#E4E4F3] dark:border-none bg-white dark:bg-[#121212] rounded-md py-3 px-4 sm:px-8">
            <div
              className="border-bottom d-flex justify-content-between align-items-center py-2 mb-4"
              style={{
                borderColor: "#E4E4F3",
                paddingTop: "0.75rem",
                paddingBottom: "0.75rem",
              }}
            >
              <h3 className="text-lg font-medium">KYC Status</h3>

              <ReviewKYCModal singleVerification={singleVerification} />
            </div>

            <div className="row mt-6 g-0">
              <div className="col-6 col-sm-3 col-md-2 px-2 px-sm-3">
                <label className="text-[#9CA3AF] dark:text-[#BCBCBC] text-sm mb-2">
                  Status:
                </label>
                <p className="text-[#151515] dark:text-white text-sm font-bold">
                  {singleVerification?.status}
                </p>
              </div>
              <div className="col-6 col-sm-3 col-md-2 px-2 px-sm-3">
                <label className="text-[#9CA3AF] dark:text-[#BCBCBC] text-sm mb-2">
                  Comment:{" "}
                </label>
                <p className="text-[#151515] dark:text-white text-sm font-bold">
                  {singleVerification?.comment}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </MainApp>
  );
}
